import { createSelector } from 'reselect';
import {
    filter, has, isEmpty, map, find, get,
} from 'lodash';
import { CONSTANTS } from 'services/constants';
import { buildHotelsSelector } from 'store/selectors/hotels.selector';
import { groupBy } from 'lodash/collection';

/**
 * Base Selectors
 */
const getMetaEntities = state => state.app.metaDatabase.destinations;
const getEntitySlug = (state, slug) => slug;
export const getDestinations = state => state.app.database.destinations;
const getDestinationPictures = state => state.app.database.destinationPictures;
const getAlternativeAttributes = state => state.app.database.alternativeAttributes;


/** * Meta Selector Builders */
export const buildMetaDestinationSelector = () => createSelector([getMetaEntities, getEntitySlug], (entities, slug) =>
{
    if (has(entities, slug)) return entities[slug];

    return {};
});

export const buildMetaDestinationsSelector = () => createSelector([getMetaEntities], (entities) =>
{
    if (!isEmpty(entities)) return entities[CONSTANTS.DATA.ALL_ID];

    return {};
});

/** * Selector Builders */
export const buildDestinationBySlugSelector = (includeRooms = false) => createSelector([getDestinations, getDestinationPictures, getEntitySlug, buildHotelsSelector(includeRooms), getAlternativeAttributes], (entities, destinationPictures, slug, hotels, alternativeAttributes) =>
{
    if (!isEmpty(entities))
    {
        const destination = find(entities, _destination => slug === _destination.slug);

        if (!destination)
            return {};

        return mapSingleDestination(
            destination,
            filter(destinationPictures, { destination_id: destination.id }),
            filter(hotels, hotel => hotel.destination_id === destination.id || hotel.destination.parent_id === destination.id),
            filter(alternativeAttributes, { entity_id: destination.id, entity_type: 'Destination' }),
        );
    }

    return {};
});

export const buildDestinationsSelector = (includeRooms = true) => createSelector([getDestinations, getDestinationPictures, buildHotelsSelector(includeRooms), getAlternativeAttributes], (entities, destinationPictures, hotels, alternativeAttributes) =>
{
    if (!isEmpty(entities)) return mapDestinations(entities, destinationPictures, hotels, alternativeAttributes);

    return [];
});

function mapSingleDestination(destination, pictures, hotels, alternativeAttributes)
{
    const destinationMainPicture = get(find(pictures, destinationPicture => destinationPicture.type === 'Gallery'), 'path');
    const mainPicture = destinationMainPicture || get(find(hotels, destinationHotel => destinationHotel.mainPicture), 'mainPicture');

    return {
        ...destination,
        mainPicture: mainPicture || '/assets/placeholder/no-image.jpg',
        destinationPictures: pictures,
        hotels,
        alternativeAttributes,
    };
}

function mapDestinations(entities, pictures, hotels, alternativeAttributes)
{
    const picturesByDestination = groupBy(pictures, 'destination_id');
    const hotelsByDestination = groupBy(hotels, 'destination_id');

    return map(entities, destination => mapSingleDestination(
        destination,
        get(picturesByDestination, destination.id, []),
        get(hotelsByDestination, destination.id, []),
        filter(alternativeAttributes, { entity_id: destination.id, entity_type: 'Destination' }),
    ));
}
